import React, {useState} from 'react';
import {LoadingContext} from './Loading.context';
import { LoadingImage, LoadingImageImilk, LoadingLabel, LoadingLabelImilk, LoadingWrapper, LoadingWrapperImilk } from './styled';
import LOGO from '../../assets/images/logo-negativa.png';
import logoImilk from '../../assets/images/logo-login-imilk-loading.png';
import { LogoRumina } from "../../components/Base/styled";
import LogoRuminaSvg from '../../assets/images/rumina-logo-horizontal.png';
import { translate } from '../../i18n/index';

const LoadingProvider = ({ children, isImilk, isStore, isAppWeb }) => {

    const [loading, tooggleLoading] = useState(false);

    const showLoading = () => {
        tooggleLoading(true);
    };

    const hideLoading = () => {
        tooggleLoading(false);
    };

    return (
        <LoadingContext.Provider value={{showLoading, hideLoading}}>
            {loading && isImilk && (
                <LoadingWrapperImilk>
                    <div style={{ margin: 'auto' }}>
                        <LoadingImageImilk src={logoImilk} />
                        <LoadingLabelImilk>{translate('labelCarregando')}</LoadingLabelImilk>
                        <div style={{ textAlign: 'center', bottom: 0, position: 'absolute', width: 440 }}>
                            <LogoRumina src={LogoRuminaSvg} alt="Logo do site" title="OnFarm" />
                        </div>
                    </div>
                </LoadingWrapperImilk>
            )}

            {loading && !isImilk && (
                <LoadingWrapper>
                    <div>
                        <LoadingImage src={LOGO} />
                        <LoadingLabel>{translate('labelCarregando')}</LoadingLabel>
                    </div>
                </LoadingWrapper>
            )}

            {children}
        </LoadingContext.Provider>
    );
};

export default LoadingProvider;
